<template>
  <div id="updateEmail">
    <form @submit.prevent="submitForm">
      <mu-text-field
        type="email"
        v-validate
        :data-vv-rules="'required|email'"
        data-vv-name="new_email"
        data-vv-value-path="inputValue"
        :data-vv-as="$t('message.securityPreferencesChangeEmail')"
        :errorText="errors.first('new_email')"
        :label="$t('message.securityPreferencesChangeEmail')"
        v-model="model.new_email"
        :hintText="$t('message.placeholderEmail')"
        fullWidth
      />
      <button type="submit" style="display: none"></button>
      <mu-raised-button
        class="large"
        @click.native="submitForm"
        :disabled="isSaving"
        :label="isSaving ? $t('message.updatingText') : $t('message.securityPreferencesSendVerificationEmail')"
        fullWidth
        secondary>
      </mu-raised-button>
    </form>
  </div>
</template>
<script>
  import axios from 'axios';
  import AccountApi from '../../api/Account';
  export default {
    name: 'email-update',
    data() {
      return {
        isSaving: false,
        model: {
          new_email: ''
        },
      }
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;
              AccountApi.updateAccountEmail(self.model.new_email).then((response) => {
                self.$toastr.success(self.$t('message.securityPreferencesCheckEmailAt') + ' ' +  self.model.new_email);
                self.isSaving = false;
                self.$router.push({
                  name: 'SettingsGeneral'
                });
              }).catch((error) => {
                if (error.response) {
                  self.$toastr.error(error.response.data.message);
                  self.isSaving = false;
                }
              });
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailUpdate.vue?ffea0334